import { jsx, jsxs } from "react/jsx-runtime";
import { CssBaseline, NoSsr } from "@mui/material";
import { deepmerge } from "@mui/utils";
import { StylesProvider } from "@mui/styles";
import { ThemeProvider } from "@mui/material/styles";
function ThemeInitializer(props) {
  const { children, ssr, theme, mergeOverrides: overrides = {} } = props;
  const composedTheme = deepmerge(theme, {
    components: overrides
  });
  return ssr ? /* @__PURE__ */ jsx(StylesProvider, { injectFirst: true, children: /* @__PURE__ */ jsxs(ThemeProvider, { theme: composedTheme, children: [
    /* @__PURE__ */ jsx(CssBaseline, {}),
    children
  ] }) }) : /* @__PURE__ */ jsx(NoSsr, { children: /* @__PURE__ */ jsxs(ThemeProvider, { theme: composedTheme, children: [
    /* @__PURE__ */ jsx(CssBaseline, {}),
    children
  ] }) });
}
export {
  ThemeInitializer
};
//# sourceMappingURL=theme.provider.js.map
